import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute, PublicRoute } from "./components/ProtectedRoute";
import { LoginPage, RegisterPage } from "./pages/AuthPages";
import { DashboardPage } from "./pages/DashboardPage";
import { DepartmentsPage } from "./pages/DepartmentsPage";
import { CampaignsPage } from "./pages/CampaignsPage";
import { CampaignEditPage } from "./pages/CampaignEditPage";
import { DomainsPage } from "./pages/DomainsPage";
import { SubmissionsPage } from "./pages/SubmissionsPage";
import { UsersPage } from "./pages/UsersPage";
import { AuditLogsPage } from "./pages/AuditLogsPage";
import { PublicCampaignPage } from "./pages/PublicCampaignPage";
import { PublicTicketPage } from "./pages/PublicTicketPage";
import { SettingsPage, AnalyticsPage } from "./pages/OtherPages";
import { MediaLibraryPage } from "./pages/MediaLibraryPage";
import { TemplateDesignerPage } from "./pages/TemplateDesignerPage";
import { TemplateLibraryPage } from "./pages/TemplateLibraryPage";
import { TicketsPage } from "./pages/TicketsPage";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Auth Routes */}
          <Route path="/login" element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          } />
          <Route path="/register" element={
            <PublicRoute>
              <RegisterPage />
            </PublicRoute>
          } />

          {/* Public Campaign Page */}
          <Route path="/c/:slug" element={<PublicCampaignPage />} />
          <Route path="/ticket/:accessToken" element={<PublicTicketPage />} />

          {/* Protected Admin Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } />
          <Route path="/departments" element={
            <ProtectedRoute allowedRoles={['super_admin', 'org_admin']}>
              <DepartmentsPage />
            </ProtectedRoute>
          } />
          <Route path="/users" element={
            <ProtectedRoute allowedRoles={['super_admin', 'org_admin', 'dept_admin']}>
              <UsersPage />
            </ProtectedRoute>
          } />
          <Route path="/campaigns" element={
            <ProtectedRoute>
              <CampaignsPage />
            </ProtectedRoute>
          } />
          <Route path="/campaigns/:id/edit" element={
            <ProtectedRoute>
              <CampaignEditPage />
            </ProtectedRoute>
          } />
          <Route path="/domains" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <DomainsPage />
            </ProtectedRoute>
          } />
          <Route path="/templates" element={
            <ProtectedRoute>
              <TemplateLibraryPage />
            </ProtectedRoute>
          } />
          <Route path="/templates/new" element={
            <ProtectedRoute>
              <TemplateDesignerPage />
            </ProtectedRoute>
          } />
          <Route path="/templates/:id/edit" element={
            <ProtectedRoute>
              <TemplateDesignerPage />
            </ProtectedRoute>
          } />
          <Route path="/submissions" element={
            <ProtectedRoute>
              <SubmissionsPage />
            </ProtectedRoute>
          } />
          <Route path="/tickets" element={
            <ProtectedRoute>
              <TicketsPage />
            </ProtectedRoute>
          } />
          <Route path="/analytics" element={
            <ProtectedRoute>
              <AnalyticsPage />
            </ProtectedRoute>
          } />
          <Route path="/audit-logs" element={
            <ProtectedRoute allowedRoles={['super_admin', 'org_admin', 'dept_admin']}>
              <AuditLogsPage />
            </ProtectedRoute>
          } />
          <Route path="/media" element={
            <ProtectedRoute>
              <MediaLibraryPage />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute allowedRoles={['super_admin']}>
              <SettingsPage />
            </ProtectedRoute>
          } />

          {/* Default Redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </AuthProvider>
  );
}

export default App;
